<template>
  <div>
    <Tabs  type="card" v-model="currenTab">
      <TabPane label="基础信息" name="baseInfo">
        <keep-alive>
          <base-add @done="baseDone" ></base-add>
        </keep-alive>
      </TabPane>
      <TabPane label="楼栋信息" name="buildInfo">
        <keep-alive>
          <build-add :projectFid="projectFid" :projectBuildingNum="projectBuildingNum" @builddone="buildDone"></build-add>
        </keep-alive>

      </TabPane>
      <TabPane label="房型信息" name="typeInfo">
        <keep-alive>
          <type-add :projectFid="projectFid"></type-add>
        </keep-alive>
      </TabPane>
    </Tabs>
    <img-show :src="imgShowSrc" :n="imgShowN"></img-show>
  </div>
</template>
<script>
  import BaseAdd from './components/BaseAdd';
  // import RunAdd from './components/RunAdd';
  import BuildAdd from './components/BuildAdd'
  import ImgShow from 'components/ImgShow/index'
  import TypeAdd from './components/TypeAdd'

  export default {
    name: "index",
    components:{
      BaseAdd,
      BuildAdd,
      ImgShow,
      TypeAdd
    },
    watch:{
      currenTab(){
        var b=document.getElementsByClassName('main-wrapper')
        b[0].scrollTop=0
      }
    },
    data(){
      return {
        currenTab:'baseInfo',
        imgShowSrc:'',
        imgShowN:0,
        projectFid:'',
        projectBuildingNum:'',
      }
    },
    methods:{
      baseDone(fid,buildNum){
        this.projectFid=fid
        this.projectBuildingNum=Number(buildNum)
        this.currenTab='buildInfo'

      },
      buildDone(){
        this.currenTab='typeInfo'
      }

    }
  }
</script>

<style scoped>

</style>
